import React from "react";
import { Box, Grid, Tab, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ROLES } from "../../../../../utilities/constants";
import CaseItem from "../components/CaseItem/CaseItem";
import useCommonStyles from "./style";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";

const CaseTabs = ({
  value,
  handleChange,
  openCases,
  closedCases,
  cases,
  selectedDept,
  role,
  history,
}) => {
  const classes = useCommonStyles();

  const tabs = [
    {
      id: "1",
      label: `Open (${openCases.count ? openCases.count : "0"})`,
      show: true,
    },
    {
      id: "2",
      label: `Closed (${closedCases.count ? closedCases.count : "0"})`,
      show: true,
    },
    {
      id: "3",
      label: `All (${cases.count ? cases.count : "0"})`,
      show: selectedDept?.headDoctor === true,
    },
    {
      id: "4",
      label: "Health Information",
      show: role !== ROLES.ROLE_RECEPTIONIST,
    },
  ].filter((tab) => tab.show);

  const renderCaseGrid = (caseData) => {
    if (!caseData || caseData.count === 0) {
      return (
        <Box className={classes.noContentContainer}>
          <Typography classes={{ root: classes.noLabel }}>
            No cases available
          </Typography>
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        {caseData.rows &&
          caseData.rows.map((caseItem) => (
            <CaseItem key={caseItem.id} caseItem={caseItem} history={history} />
          ))}
      </Grid>
    );
  };

  return (
    <>
      <Box mt={2}>
        <TabContext value={value}>
          <Box className={classes.tabsContainer}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              className={classes.tabList}
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.id}
                  label={tab.label}
                  value={tab.id}
                  className={classes.tab}
                />
              ))}
            </TabList>
          </Box>

          <TabPanel value="1" className={classes.tabPanels}>
            {renderCaseGrid(openCases)}
          </TabPanel>
          <TabPanel value="2" className={classes.tabPanels}>
            {renderCaseGrid(closedCases)}
          </TabPanel>
          <TabPanel value="3" className={classes.tabPanels}>
            {renderCaseGrid(cases)}
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export default CaseTabs;
